import React from 'react';
import Triggers from "../../webchat-conf/Triggers";
import {updateClientWebChatTriggerConf} from "../../../../../../../services/company/api";


const TriggerSettings = ({
                             commonStyles,
                             triggers,
                             setTriggers,
                             clientId
                         }) => {
    const saveTriggers = (updateData) => {
        const updatedTriggers = {...triggers, ...updateData};
        updateClientWebChatTriggerConf(clientId, updatedTriggers).then(() => setTriggers(updatedTriggers));
    };

    return (
        <Triggers commonStyles={commonStyles} triggers={triggers} saveTriggers={saveTriggers}/>
    );
};

export default TriggerSettings;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/clients/new/functions/TriggerSettings.jsx